import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const ExpandButton = styled.a<IWithSize & { disabled?: boolean }>`
  width: ${({ size }) => (size ? 24 * size : 24)}px;
  height: ${({ size }) => (size ? 24 * size : 24)}px;
  min-width: ${({ size }) => (size ? 24 * size : 24)}px;
  min-height: ${({ size }) => (size ? 24 * size : 24)}px;
  border-radius: 3px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};

  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-right: ${({ size }) => (size ? 15 * size : 15)}px;
  cursor: pointer;

  color: inherit;
  text-decoration: inherit;

  ${is('disabled')` 
    cursor: unset;
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
    color: ${(props: ITheme) => props.theme.colors.palette.pinkishGrey};
  `}

  ${isNot('disabled')`
    &:hover {
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.warmGreytThree};
    }
  `}
`
export default ExpandButton
